import React from 'react';
import { IActivityRecord } from 'interfaces';

type Props = {
    insight: IActivityRecord;
};

const ExternalInsightFrame = React.memo(({ insight }: Props) => (
    <div style={{ minHeight: 2000 }}>
        <iframe
            // double cast via `unknown` because `insight` is typed as an object;
            // for the external_source case the BE sends a URL string instead
            src={(insight.insightsData.insight as unknown) as string}
            title={insight.insightsData.name}
            style={{ width: '100%', height: 2000, border: 'none' }}
        />
    </div>
));

export default ExternalInsightFrame;
